"use client";

import { SetStateAction, useEffect, useState, Dispatch } from "react";

export function localStorageProvider() {
  if (typeof window == "undefined") return new Map();
  // When initializing, we restore the data from `localStorage` into a map.
  const map = new Map(JSON.parse(localStorage.getItem("app-cache") || "[]"));

  // Before unloading the app, we write back all the data into `localStorage`.
  window.addEventListener("beforeunload", () => {
    const appCache = JSON.stringify(Array.from(map.entries()));
    localStorage.setItem("app-cache", appCache);
  });

  // We still use the map for write & read for performance.
  return map;
}

export function useLocalStorage(
  key: string,
  initialState?: Record<string, any>,
  retailFlag?: boolean
): [state: any, setState: Dispatch<SetStateAction<any>>] {
  // const updatedInitialState = {
  //   ...initialState,
  //   phoneNumber: !retailFlag
  //     ? ((parseInt(initialState?.phoneNumber) - 931) / 77).toString()
  //     : initialState?.phoneNumber,
  // };
  if (!retailFlag && initialState) {
    initialState["phoneNumber"] = (
      (parseInt(initialState?.phoneNumber) - 931) /
      77
    ).toString();
  }
  const [state, setState] = useState<any>(initialState || {});
  const [firstRender, setFirstRender] = useState(true);

  useEffect(() => {
    const savedValue = localStorage.getItem(key);
    let travelKeys = localStorage.getItem("form1");
    if (travelKeys) {
      travelKeys = JSON.parse(travelKeys);
    }
    if (savedValue && savedValue != "undefined") {
      //console.log("here")
      if (retailFlag) {
        setState({ ...state, ...JSON.parse(savedValue as string) });
      } else {
        setState({ ...JSON.parse(savedValue as string), ...state });
      }
    } else if (travelKeys) {
      //console.log("travelKeys['mobileNumber']", travelKeys);
      setState({
        ...state,
        ...JSON.parse(
          JSON.stringify({
            savedValue,
            ...{ phoneNumber: travelKeys["mobileNumber"] },
          })
        ),
      });
      state["phoneNumber"] = travelKeys["mobileNumber"];
      localStorage.setItem(key, JSON.stringify(state));
    } else {
      localStorage.setItem(key, JSON.stringify(state));
    }
    setFirstRender(false);
  }, []);

  useEffect(() => {
    if (firstRender) return;
    localStorage.setItem(key, JSON.stringify(state));
  }, [state, firstRender]);

  return [state, setState];
}
